import {
  selectFavouriteRecipeIds,
  selectFavouriteWorkoutIds,
  mapIsFavouriteRecipes,
  mapIsFavouriteWorkouts,
} from 'logic/favourite';

import {
  fetchRecipeCollection,
  fetchRecipeInspiration,
  selectRecipeCollection,
  selectRecipeInspiration,
} from 'logic/recipe';

import {
  fetchWorkoutCollection,
  fetchWorkoutInspiration,
  fetchWorkoutVideoCurrent,
  selectWorkoutCollection,
  selectWorkoutInspiration,
  selectWorkoutVideo,
} from 'logic/workout';

import {
  selectHasNutritionSubscription,
  selectHasWorkoutSubscription,
  selectMember,
  selectMemberLevel,
  selectSubscription,
} from 'logic/member';

import {
  fetchMealPlan,
  fetchMealPlanActive,
  fetchMealPlansByVoome,
  fetchMealPlansCurrent,
  selectPaginationByType,
  selectDays,
  selectMealPlan,
  selectMealPlansCurrent,
  selectMealPlanList,
} from 'logic/mealPlan';

export const Dashboard = {
  template: `
    <div class="dashboard">
      <div class="main-content bg-gray-dashboard d-flex flex-column">
        <div class="mb-3"
          ng-class="{
            'order-1': $ctrl.hasNutrition,
            'order-2': !$ctrl.hasNutrition
          }">
          <div ng-show="$ctrl.hasNutrition">
            <dashboard-nutrition-container
              active-card="1"
              index="$ctrl.dayIndex"
              recipe-inspiration="$ctrl.recipeInspiration"
              recipe-collection="$ctrl.recipeCollection"
              meal-plan="$ctrl.mealPlan"
              meal-plan-list="$ctrl.mealPlanList"
              meal-plans-current="$ctrl.mealPlansCurrent"
              meal-plans-total="$ctrl.mealPlansTotal"
              subscription-id="$ctrl.subscription.id">
            </dashboard-nutrition-container>
          </div>
          <div ng-show="$ctrl.hasWorkout && !$ctrl.hasNutrition">
            <dashboard-nutrition-upgrade recipe-collection="$ctrl.recipeCollection">
            </dashboard-nutrition-upgrade>
          </div>
        </div>
        <div class="order-3 mb-3 pt-4 pb-4 bg-gray-dashboard">
          <footer-dashboard></footer-dashboard>
        </div>
      </div>
    </div>`,

  controller($ngRedux) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);
        this.dayIndex = new Date().getDay();

        if (!this.recipeInspiration.length) {
          this.fetchRecipeInspiration(this.member.id, this.level);
        }

        if (!this.mealPlan.id) {
          this.fetchMealPlanActive();
        }

        if (!this.mealPlansCurrent.length) {
          this.fetchMealPlansCurrent(this.subscription.id);
        }

        if (!this.mealPlansTotal) {
          this.fetchMealPlansByVoome(this.subscription.id);
        }

        if (!this.recipeCollection) {
          this.fetchRecipeCollection(
            'current',
            this.subscription.voomeProductId
          );
        }

        if (!this.workoutInspiration.length) {
          this.fetchWorkoutInspiration(this.member.id);
        }

        if (!this.workoutCollection) {
          this.fetchWorkoutCollection(
            'current',
            this.subscription.voomeProductId
          );
        }

        if (!this.workoutVideo) {
          this.fetchWorkoutVideoCurrent(this.subscription.voomeProductId);
        }
      },

      $onDestroy() {
        this.disconnect();
      },

      mapState({ favourite, mealPlan, member, recipe, workout }) {
        const favouriteRecipeIds = selectFavouriteRecipeIds(favourite);
        const favouriteWorkoutIds = selectFavouriteWorkoutIds(favourite);

        return {
          level: selectMemberLevel(member),
          member: selectMember(member),
          subscription: selectSubscription(member),
          hasNutrition: selectHasNutritionSubscription(member),
          hasWorkout: selectHasWorkoutSubscription(member),

          // Recipe Inspiration
          recipeInspiration: mapIsFavouriteRecipes(
            selectRecipeInspiration(recipe),
            favouriteRecipeIds
          ),

          // Recipe Collection
          recipeCollection: mapIsFavouriteRecipes(
            selectRecipeCollection(recipe, recipe.result),
            favouriteRecipeIds
          ),

          // Mealplans
          mealPlan: selectMealPlan(mealPlan, mealPlan.active),
          mealPlanList: selectMealPlanList(mealPlan, mealPlan.active),
          mealPlansCurrent: selectMealPlansCurrent(mealPlan),
          mealPlansTotal: selectPaginationByType(mealPlan, 'byVoome').total,

          workoutInspiration: mapIsFavouriteWorkouts(
            selectWorkoutInspiration(workout),
            favouriteWorkoutIds
          ),

          workoutCollection: mapIsFavouriteWorkouts(
            selectWorkoutCollection(workout, workout.result),
            favouriteWorkoutIds
          ),

          // Workout video
          workoutVideo: selectWorkoutVideo(workout, workout.currentVideoId),
        };
      },

      mapDispatch() {
        return {
          fetchMealPlan,
          fetchMealPlanActive,
          fetchMealPlansByVoome,
          fetchMealPlansCurrent,
          fetchRecipeCollection,
          fetchRecipeInspiration,
          fetchWorkoutCollection,
          fetchWorkoutInspiration,
          fetchWorkoutVideoCurrent,
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/Dashboard.js